let $ = require('jquery');

export default class Custom {
    init() {
        Init();
    }
}

function Init() {
    $(document).ready(function () {

        // Brand-Slider
        //$('.brand-slider').slick({
        //    infinite: true,
        //    speed: 300,
        //    slidesToShow: 4,
        //    slidesToScroll: 0,
        //    adaptiveHeight: true,
        //    autoplay: false,
        //    responsive: [
        //        {
        //            breakpoint: 767,
        //            settings: {
        //                slidesToShow: 2,
        //                slidesToScroll: 2
        //            }
        //        },
        //        {
        //            breakpoint: 480,
        //            settings: {
        //                slidesToShow: 1,
        //                slidesToScroll: 1
        //            }
        //        }
        //    ],
        //});

        // Menu Toggle
        $(".cd-dropdown-trigger").click(function () {
            $(".navigation").css({ "top": "63px" });
            $("body").css({ "overflow": "hidden" });
            $(".cd-dropdown-trigger").css({ "display": "none" });
            $(".cd-dropdown-trigger-x").css({ "display": "block" });
        });

        $(".cd-dropdown-trigger-x").click(function () {
            $(".navigation").css({ "top": "-110%" });
            $("body").css({ "overflow": "auto" });
            $(".cd-dropdown-trigger").css({ "display": "block" });
            $(".cd-dropdown-trigger-x").css({ "display": "none" });
        });


        // Sticky Header JS
        $(window).scroll(function () {
            if ($(this).scrollTop() > 1 && $(this).width() > 767) {
                $('.header').addClass("sticky");
            }
            else {
                $('.header').removeClass("sticky");
            }
        });

        // datepicker           
        //$("#date-pick").datepicker({
        //    showOtherMonths: true,
        //    selectOtherMonths: true
        //});

        //$('.calender-ic').click(function () {
        //    $('#date-pick').focus();
        //});

        // Selectmenu
        //$(".files").selectmenu();

        // Autoselect
        var availableTags = [
            "London United Kingdom",
            "Long Beach CA, USA",
            "London ON, Canada",
            "Long Island City Que...",

        ];
        //$(".zip").autocomplete({
        //    source: availableTags
        //});

        //Sticky Sidebar
        $(".sticky-btn").click(function () {
            $(".sticky-sidebar").toggleClass("openwindow");
        });
        //auto open on start 
        $(".sticky-sidebar").addClass("autoopened openwindow");
        //close on first scroll
        $(window).scroll(function () {
            if ($(".sticky-sidebar").hasClass("autoopened")) {
                $(".sticky-sidebar").toggleClass("openwindow");
                $(".sticky-sidebar").removeClass("autoopened");
            }
        });


        $(".close-btn").click(function () {
            $($(this).parents()[1]).find(".coupon-info").slideUp();
            $($($(this).parents()[1]).find(".close-btn")).attr('style', 'display: none');
            $($($(this).parents()[1]).find(".readmore-btn")).attr('style', 'display:block');
        });

        $(".readmore-btn").click(function () {
            $($(this).parents()[1]).find(".coupon-info").slideDown();
            $($($(this).parents()[1]).find(".readmore-btn")).attr('style', 'display: none');
            $($($(this).parents()[1]).find(".close-btn")).attr('style', 'display:block');
        });
    });
}


// WEBPACK FOOTER //
// ./Src/Shared/Legacy/custom.js